import { render, staticRenderFns } from "./taxInfoList.vue?vue&type=template&id=25f4c76f&scoped=true&"
import script from "./taxInfoList.vue?vue&type=script&lang=js&"
export * from "./taxInfoList.vue?vue&type=script&lang=js&"
import style0 from "./taxInfoList.vue?vue&type=style&index=0&id=25f4c76f&prod&scoped=true&lang=css&"
import style1 from "./taxInfoList.vue?vue&type=style&index=1&id=25f4c76f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f4c76f",
  null
  
)

export default component.exports